// frontend/src/components/common/InlineMessage.tsx
import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { styled } from '@mui/material/styles';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';

interface InlineMessageProps {
  message: string;
  severity?: 'error' | 'warning' | 'info' | 'success';
  title?: string;
  icon?: React.ReactNode;
  dismissible?: boolean;
  onClose?: () => void;
}

const StyledAlert = styled(Alert)({
  marginTop: '.2rem',
  marginBottom: '.7rem',
  lineHeight: '2rem',
  padding: '.5rem',
  fontSize: '1.6rem',
  '& .MuiAlert-message': {
    fontWeight: 500,
  },
  '& .MuiAlert-icon': {
    opacity: 1,
  },
  '& svg': {
    fontSize: '2.9rem',
  },
});

export const InlineMessage: React.FC<InlineMessageProps> = ({
  message,
  severity = 'error',
  title,
  icon,
  dismissible = false,
  onClose,
}) => {
  return (
    <StyledAlert
      severity={severity}
      icon={icon}
      variant="filled"
      onClose={dismissible ? onClose : undefined}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </StyledAlert>
  );
};
